import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getEstadosCiviles = query =>
	fetch.get(
		`/estados-civiles${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getEstadoCivil = ({ id, query }) =>
	fetch.get(
		`/estados-civiles/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addEstadoCivil = data => fetch.post('/estados-civiles', data);
export const updateEstadoCivil = ({ id, ...data }) =>
	fetch.put(`/estados-civiles/${id}`, data);
export const deleteEstadoCivil = id => fetch.delete(`/estados-civiles/${id}`);

// RTK Query
export const estadosCivilesApi = createApi({
	reducerPath: 'estadosCivilesApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getEstadosCiviles: build.query({
			query: query => {
				return {
					url: `/estados-civiles${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'EstadosCiviles',
								id,
							})),
							{ type: 'EstadosCiviles', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'EstadosCiviles', id: 'LIST' }],
		}),
		getEstadoCivil: build.query({
			query: ({ id, query }) => {
				return {
					url: `/estados-civiles/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'EstadosCiviles', id }],
		}),
		addEstadoCivil: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-civiles`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Estado Civil agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar estado civil');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'EstadosCiviles', id: 'LIST' }],
		}),
		updateEstadoCivil: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-civiles/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Estado Civil actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar estado civil');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'EstadosCiviles', id },
			],
		}),
		deleteEstadoCivil: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-civiles/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Estado Civil eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar estado civil');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'EstadosCiviles', id },
			],
		}),
	}),
});

export const {
	useGetEstadosCivilesQuery,
	useGetEstadoCivilQuery,
	useAddEstadoCivilMutation,
	useUpdateEstadoCivilMutation,
	useDeleteEstadoCivilMutation,
} = estadosCivilesApi;
